import { useState } from "react";

import { tonUsdtPaymentsApi } from "@/api/tonUsdtPaymentsApi";

import type { TonUsdtInvoice } from "@/types/tonUsdtPayment";

export const useTonUsdtPayment = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createInvoice = async (amountUsdt: string): Promise<TonUsdtInvoice> => {
    setIsSubmitting(true);

    try {
      return await tonUsdtPaymentsApi.createInvoice({
        amount_usdt: amountUsdt,
        idempotency_key: crypto.randomUUID(),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    createInvoice,
  };
};
